export const FlagEmoji = ({ countryCode }: { countryCode: string }) => {
  let countryCodeToUse = countryCode;

  // This is a special case for the United States, which is represented by the code '001' in the Zendesk API.
  // We need to map this to the correct country code for the flag.
  if (countryCode === '001') {
    countryCodeToUse = 'us';
  }

  return (
    <img
      src={`https://flagcdn.com/144x108/${countryCodeToUse}.png`}
      width="16"
      height="12"
      alt={countryCode}
      loading="lazy"
    />
  );
};
